import styled from "styled-components";

import { IThemeProps } from "@/styles";

type GroupProps = IThemeProps<{
  $delay: number;
}>;
const Group = styled.div<GroupProps>`
  position: relative;
  transition: all 0.25s linear;
  transition-delay: ${(props: GroupProps) => props.$delay}ms;
`;

export const TextGroup = styled(Group)`
  display: block;
  width: 100%;
  margin-bottom: ${(props: GroupProps) => props.theme.spacing.desktop.s300}px;
  &:last-child {
    margin-bottom: 0;
  }

  @media ${(props: GroupProps) => props.theme.breakpoints.mobile} {
    margin-bottom: ${(props: GroupProps) => props.theme.spacing.mobile.s500}px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const ImageGroup = styled(Group)`
  margin-top: 14px;
  @media ${(props: GroupProps) => props.theme.breakpoints.mobile} {
    margin-top: 7px;
  }

  &:nth-child(-n + 2) {
    margin-top: 0;
  }
`;

export const NodeWrapperExtended = styled.div`
  max-width: 510px;
  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    max-width: 310px;
  }
  margin: 0 auto;
  display: flex;
  flex-flow: wrap;
  justify-content: center;
`;

export const ImageGroupExtended = styled(Group)`
  margin: 14px;
  @media ${(props: GroupProps) => props.theme.breakpoints.mobile} {
    margin: 7px;
  }
`;
